/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReportSessionMovedRequestBody,
  ReportSessionMovedRequestBody$Outbound,
  ReportSessionMovedRequestBody$outboundSchema,
} from "../components/reportsessionmovedrequestbody.js";

export type ReportAgentSessionMovedSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type ReportAgentSessionMovedRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Hardware serial number of the machine the move happened on, when the agent can read it.
   */
  gramDeviceSerial?: string | undefined;
  /**
   * Hostname of the machine the move happened on, when the agent can read it.
   */
  gramDeviceHostname?: string | undefined;
  reportSessionMovedRequestBody: ReportSessionMovedRequestBody;
};

/** @internal */
export type ReportAgentSessionMovedSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ReportAgentSessionMovedSecurity$outboundSchema: z.ZodMiniType<
  ReportAgentSessionMovedSecurity$Outbound,
  ReportAgentSessionMovedSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function reportAgentSessionMovedSecurityToJSON(
  reportAgentSessionMovedSecurity: ReportAgentSessionMovedSecurity,
): string {
  return JSON.stringify(
    ReportAgentSessionMovedSecurity$outboundSchema.parse(
      reportAgentSessionMovedSecurity,
    ),
  );
}

/** @internal */
export type ReportAgentSessionMovedRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Device-Serial"?: string | undefined;
  "Gram-Device-Hostname"?: string | undefined;
  ReportSessionMovedRequestBody: ReportSessionMovedRequestBody$Outbound;
};

/** @internal */
export const ReportAgentSessionMovedRequest$outboundSchema: z.ZodMiniType<
  ReportAgentSessionMovedRequest$Outbound,
  ReportAgentSessionMovedRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramDeviceSerial: z.optional(z.string()),
    gramDeviceHostname: z.optional(z.string()),
    reportSessionMovedRequestBody: ReportSessionMovedRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramDeviceSerial: "Gram-Device-Serial",
      gramDeviceHostname: "Gram-Device-Hostname",
      reportSessionMovedRequestBody: "ReportSessionMovedRequestBody",
    });
  }),
);

export function reportAgentSessionMovedRequestToJSON(
  reportAgentSessionMovedRequest: ReportAgentSessionMovedRequest,
): string {
  return JSON.stringify(
    ReportAgentSessionMovedRequest$outboundSchema.parse(
      reportAgentSessionMovedRequest,
    ),
  );
}
